import React, { createContext, useContext, useState } from 'react'

const DataContext = createContext()

export const DataContextProvider = ({ children }) => {
  const [selectedSolarPlant, setSelectedSolarPlant] = useState([])
  const [selectedWind2Plant, setSelectedWind2Plant] = useState([])

  return (
    <DataContext.Provider
      value={{
        selectedSolarPlant,
        setSelectedSolarPlant,
        selectedWind2Plant,
        setSelectedWind2Plant,
      }}
    >
      {children}
    </DataContext.Provider>
  )
}

export const useData = () => useContext(DataContext)
export default DataContext
